import { Container, CardActionArea, Grid, Button } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import React from "react";
import "../component/css/Demo.css";
const Demo = () => {
  const [e, setE] = React.useState("");
  return (
    <div>
      <div className="hover-card">
        <div id="card-demo-flex">
          <div className="cards-demo">
            <div style={{ padding: "6px" }}>
              <h3>Service</h3>
            </div>
            <div style={{ padding: "5px" }}>
              <h4>We Provide..</h4>
            </div>
            <span style={{ padding: "10px" }}>
              <p>
                We care about your security and privacy and thus we want to
                ensure it, and thus we created a platform where we concern your
                data, security and money.
              </p>
            </span>
          </div>
        </div>
        <div className="video-card">
          <video
            src="https://res.cloudinary.com/codelife/video/upload/v1637805738/intro_l5ul1k.mp4"
            controls
            autoplay
            loop
            width="350px"
            height="150px"
            className="video"
          ></video>
        </div>
      </div>

      <div style={{ background: "rgb(237,204,73)" }}>
        <Container>
          <center>
            <h2 style={{ padding: "50px" }}> What we provide</h2>{" "}
          </center>
          <Grid
            container
            direction="row"
            justifyContent="space-around"
            alignItems="center"
            gap="5px"
            style={{ padding: "50px" }}
            className="grid-cards"
          >
            <Card
              sx={{ maxWidth: 345 }}
              className="cards"
              data-aos="flip-right"
            >
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="140"
                  image={require("../component/images/FV.png")}
                  alt="green iguana"
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    Fully verified Detection
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    It detects malicious malware with real time protection with
                    deep scan and ram booster.
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
            <Card sx={{ maxWidth: 345 }} className="cards" data-aos="flip-left">
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="140"
                  image={require("../component/images/Demo_Service.png")}
                  alt="green iguana"
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    Services
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    We are working and offering variety of services which helps
                    user to be secure from day to day malicious activity that
                    may harm and squander us without our consciousness.
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        </Container>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          padding: "40px",
          backgroundColor: "#334455",
        }}
      >
        <center>
          <h2 style={{ fontFamily: "cursive	", fontWeight: "700" }}>
            <span style={{ color: "orange" }}>Get a Demo </span>through your
            mail
          </h2>
          <p style={{ color: "#fff" }}>
            Mail and we'll send you the best Demos straight to your inbox.
          </p>
        </center>
        <div className="input-div">
          <input
            type="email"
            name="email"
            placeholder="Enter a gmail address"
            pattern=".+@gmail.com"
            className="input-mail"
            value={e}
            onChange={(e) => {
              setE(e.target.value);
            }}
          />
          {e.length === 0 ? (
            <Button style={{ backgroundColor: "white", color: "black" }}>
              Please write the mail
            </Button>
          ) : (
            <Button
              style={{ backgroundColor: "#C21318", color: "White" }}
              onClick={() => {
                window.location = "mailto:" + e + "?body=Hello Abhishek";
              }}
            >
              Get Demo
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Demo;
